import script from "./DateButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DateButton.vue?vue&type=script&setup=true&lang=js"

import "./DateButton.vue?vue&type=style&index=0&id=24212137&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24212137"]])

export default __exports__